import React,{useState,useRef} from 'react'
import { useFormContext } from '../Context/FormContext';
import { Checkbox } from 'antd';

const CopyCheckbox = ({toggleCheckbox}) => {

  return (

    <div>

        <Checkbox onChange={toggleCheckbox}>Copy above details</Checkbox>

    </div>

  )

}


export default CopyCheckbox